import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableCell, TableRow } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card, CardContent } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png";
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent';
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player';
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling'
import Skeleton from '@material-ui/lab/Skeleton';
import DifficultySlider from "./feedbackSliderDifficulty";
import PainSlider from "./feedbackSliderPain";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import FlagExerciseForReview from "./flagExercise";
import SlowMotionVideoIcon from '@material-ui/icons/SlowMotionVideo';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import WarningIcon from '@material-ui/icons/Warning';
import ListAltIcon from '@material-ui/icons/ListAlt';

//import FeedbackComp from './feedback';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  card: {
    background: 'linear-gradient(90deg, #dce4eb, #cfd1d7ff)',
    borderRadius: 16,
    boxShadow: "0 8px 20px rgba(2,26,50,0.12), 0 2px 6px rgba(2,26,50,0.08)",
    padding: 24,
    
    [theme.breakpoints.down('lg')]: {
      padding: 20,
    },
    [theme.breakpoints.down('md')]: {
      padding: 16,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 12,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 8,
    },
  },
  paper: {
    borderRadius: 16,
    padding: 8,
    boxShadow: "0 8px 20px rgba(2,26,50,0.12), 0 2px 6px rgba(2,26,50,0.08)",
    background: "linear-gradient(220deg, rgba(185, 204, 231, 0.55), #6a8caf)",
    //background: 'linear-gradient(90deg, #6a8caf, #002D55)',
    width: "100%",
    maxWidth: 550,
  minHeight: 300,
    boxSizing: "border-box",
    [theme.breakpoints.down('lg')]: {
      maxWidth: 550,
  minHeight: 250,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 550,
  minHeight: 180,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
  minHeight: 100,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 400,
  minHeight: 60,
    },
  },
  img: {
    maxHeight: 280,
    maxWidth: "100%",
    borderRadius: 14,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    objectFit: "cover",
    [theme.breakpoints.down('lg')]: {
      maxHeight: 220,
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: 180,
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: 120,
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 80,
    },
  },
  h5: {
    color: '#002D55',
    fontWeight: 800,
    marginBottom: 0,
    marginTop: 0,
    textAlign: 'center',
    letterSpacing: 0.04,
    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.15rem', marginTop: 0 },
    [theme.breakpoints.down('lg')]: { fontSize: '1.1rem', marginTop: 0 },
    [theme.breakpoints.down('md')]: { fontSize: '1rem', marginTop: 0 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.95rem', marginTop: 0 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.9rem', marginTop: 0 }
  },
  h5Index: {
    color: "#767676ff",
    marginTop: 0,
    marginLeft: 8,
    minWidth: 55,
    fontWeight: 400,
    fontSize: 22,
    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.15rem', marginTop: 0 },
    [theme.breakpoints.down('lg')]: { fontSize: '1.1rem', marginTop: 0 },
    [theme.breakpoints.down('md')]: { fontSize: '1rem', marginTop: 0 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.95rem', marginTop: 0 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.9rem', marginTop: 0 },
  },
  button: {
    backgroundColor: "#e3eafc",
    color: "#002D55",
    fontWeight: 600,
    fontSize: 'clamp(10px, 1.15vw, 18px)',
    margin: "4px",
    padding: "8px 24px",
    borderRadius: 14,
    boxShadow: "none",
    textTransform: "none",
    display: "inline-flex",
    alignItems: "center",
    [theme.breakpoints.down('lg')]: {
      padding: "7px 20px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "6px 16px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "5px 12px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "4px 8px",
    },
  },
  description: {
    color: "#002D55",
    fontWeight: "normal",
    margin: 12,
    maxHeight: 'min(24vh, 220px)',
    overflowY: 'auto',
    whiteSpace: 'pre-line',
    paddingRight: 8,
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.85rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
  descriptionTitle: {
    color: "#002D55",
    fontWeight: "normal",
    marginBottom: 8,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    fontSize: 'clamp(10px, 1.3vw, 20px)',
  },
  continueButton: {
    boxShadow: "none",
    textTransform: "none",
    display: "flex",
    justifyContent: "center",
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: "15px 20px",
    width: "48%",
    border: "0.5px solid",
    fontWeight: 700,
    lineHeight: 0.5,
    borderRadius: 18,
    backgroundColor: "#fb741a",
    borderColor: "transparent",
    color: "#FFFFFF",
    '&:hover': {
      background: '#002D55'
    },
    '&:active': {
      background: '#002D55',
      transform: 'translateY(1px)'
    },
    [theme.breakpoints.down('lg')]: {
      padding: "16px 12px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "14px 30px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "12px 8px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "10px 8px",
    },
  },
  skipButton: {
    boxShadow: "none",
    textTransform: "none",
    display: "flex",
    justifyContent: "center",
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: "15px 20px",
    width: "48%",
    border: "0.5px solid",
    fontWeight: 700,
    lineHeight: 0.5,
    borderRadius: 18,
    backgroundColor: "#ccc",
    borderColor: "#ccc",
    color: "#FFFFFF",
    '&:hover': {
      background: '#002D55'
    },
    '&:active': {
      background: '#002D55',
      transform: 'translateY(1px)'
    },
    [theme.breakpoints.down('lg')]: {
      padding: "16px 12px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "14px 30px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "12px 8px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "10px 8px",
    },
  },
}));

const ContinueButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 'clamp(12px, 1vw, 15px)',
    padding: "15px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
        boxShadow: "none",
        backgroundColor: "#e6eaf0",
        borderColor: "#e6eaf0"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

const UploadVideoButton = withStyles({
  root: {
    boxShadow: "none",
    scale: "0.8",
    textTransform: "none",
    fontSize: 'clamp(12px, 1vw, 15px)',
    padding: "10px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#1a90ff",
    borderColor: "#1a90ff",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#1a90ff",
      borderColor: "#1a90ff",
      boxShadow: "none"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

const ExerciseIntro = (props) => {
  const className = props.className

  const classes = useStyles();

  const { innerWidth: width, innerHeight: height } = window;

  const [difficulty, setDifficulty] = useState(0)
  const [pain, setPain] = useState(20)
  const [guidanceDrawer, setGuidanceDrawer] = useState(null);
  const isAscendExercise = String(props.exercise?.source || '').toLowerCase() === 'ascend';
  const extractLegacyGuidance = (sectionName, followingSections) => {
    const description = String(props.exercise?.description || '');
    const section = description.split(new RegExp(`\\b${sectionName}:\\s*`, 'i'))[1] || '';
    const content = section.split(new RegExp(`\\b(?:${followingSections.join('|')}):\\s*`, 'i'))[0];
    return content.split('\n').map(item => item.trim().replace(/^\d+\.\s*/, '')).filter(Boolean);
  };
  const instructionText = Array.isArray(props.exercise?.instructions)
    ? props.exercise.instructions.map((instruction, index) => `${index + 1}. ${instruction}`).join('\n')
    : '';
  const tips = Array.isArray(props.exercise?.tips) && props.exercise.tips.length
    ? props.exercise.tips
    : extractLegacyGuidance('Tips', ['Common mistakes', 'Variations']);
  const commonMistakes = Array.isArray(props.exercise?.commonMistakes) && props.exercise.commonMistakes.length
    ? props.exercise.commonMistakes
    : extractLegacyGuidance('Common mistakes', ['Variations']);
  const legacyInstructions = String(props.exercise?.description || '')
    .split(/\bInstructions:\s*/i)[1]
    ?.split(/\b(?:Tips|Common mistakes|Variations):\s*/i)[0]
    ?.trim() || '';
  const displayDescription = isAscendExercise && instructionText
    ? instructionText
    : isAscendExercise
      ? legacyInstructions
      : props.exercise?.description;
  const displayInstructions = String(displayDescription || '').split('\n').filter(Boolean);
  const doseType = props.exercise?.doseType || (
    props.exercise?.time != null && props.exercise.time > 0 ? 'time' : 'repetitions'
  );
  const isStrengthDose = ['repetition_maximum', 'weight_kg', 'weight_total_kg', 'weight_lbs', 'weight_total_lbs'].includes(doseType);


  const [token, _] = useState(useSelector(state => state.auth.token))

 

  return (
    <Popover
      PaperProps={{ style: { borderRadius: 16 } }}
      open={props.open}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: window.innerHeight / 2,
        left: window.innerWidth / 2
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <div style={{ borderRadius: 16, width: "100%", height: '100%', display: "flex", justifyContent: "center", alignItems: "center", background: "#fff" }}>
        <Paper elevation={4} className={classes.paper} style={{ height: '100%' }}>
          <Card elevation={2} className={classes.card} style={{ height: '100%' }}>
            <Grid container direction="column" justify="center" alignItems="center" style={{ width: "100%" }}>
              <Grid item xs={12} style={{ width: "100%", marginBottom: 'clamp(10px, 1.1vw, 16px)' }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%", marginBottom: 'clamp(5px, 0.6vw, 8px)' }}>
                  <Typography
                    variant="h5"
                    className={classes.h5}
                  >
                    {props.exercise.title}
                  </Typography>
                  <Typography
                    variant="h5"
                    className={classes.h5Index}
                  >
                    ({props.currentExerciseIndex + 1} / {props.totalExercises})
                  </Typography>
                </div>
                {props.exercise.img && (
                  <div style={{ display: "flex", justifyContent: "center", marginBottom: 'clamp(10px, 1vw, 15px)', marginTop: 'clamp(6px, 0.7vw, 10px)' }}>
                    <img
                      src={props.exercise.img}
                      alt={props.exercise.title}
                      className={classes.img}
                    />
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "0.5%" }}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      width: '100%',
                      marginTop: 0,
                      marginBottom: 0,
                      gap: 'clamp(8px, 0.9vw, 12px)',
                      flexWrap: 'wrap',
                    }}
                  >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    style={{
                      background: '#f7f9fc',
                      borderRadius: 14,
                      padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                      boxShadow: '0 1px 4px rgba(0,45,85,0.04)',
                      marginRight: 0,
                      marginBottom: 'clamp(4px, 0.4vw, 6px)',
                    }}
                  >
                    <SlowMotionVideoIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                    <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                      {`${props.exercise.sets || 0} sets`}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    style={{
                      background: '#f7f9fc',
                      borderRadius: 14,
                      padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                      boxShadow: '0 1px 4px rgba(0,45,85,0.04)',
                      marginBottom: 'clamp(4px, 0.4vw, 6px)',
                    }}
                  >
                    {isStrengthDose
                      ? <FitnessCenterIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                      : <PlayCircleOutlineIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />}
                    <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                      {(() => {
                        // Mirror the rest of the app: explicit doseType wins,
                        // otherwise non-zero time means time-based, else repetitions-based.
                        if (doseType === 'repetition_maximum') {
                          return `${props.exercise.repetitionMaximum || 0} RM`;
                        }
                        if (doseType === 'weight_kg') return `${props.exercise.weightKg || 0} kg`;
                        if (doseType === 'weight_total_kg') return `${props.exercise.weightTotalKg || 0} total kg`;
                        if (doseType === 'weight_lbs') return `${props.exercise.weightLbs || 0} lbs`;
                        if (doseType === 'weight_total_lbs') return `${props.exercise.weightTotalLbs || 0} total lbs`;
                        return doseType === 'time'
                          ? `${props.exercise.time || 0} seconds`
                          : `${props.exercise.repetitions || 0} reps`;
                      })()}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    style={{
                      background: '#f7f9fc',
                      borderRadius: 14,
                      padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                      boxShadow: '0 1px 4px rgba(0,45,85,0.04)',
                      marginBottom: 'clamp(4px, 0.4vw, 6px)',
                    }}
                  >
                    <PauseCircleOutlineIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                    <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                      {`Pause: ${parseInt(props.exercise.pause, 10) || 0} sec`}
                    </Typography>
                  </Box>
                </Box>
                </div>
                <Divider style={{ width: '100%', margin: '10px 0 10px 0', background: '#e0e5ee' }} />
                <Box className={classes.description} style={{ maxHeight: 'min(24vh, 220px)', overflowY: 'auto', paddingRight: 8 }}>
                  <Typography
                    variant="body1"
                    style={{
                      color: '#002D55',
                      fontWeight: 'normal',
                      fontSize: 'inherit',
                      whiteSpace: 'pre-wrap',
                      margin: 0,
                    }}
                  >
                    {isAscendExercise
                      ? displayInstructions.map((instruction, index) => {
                        const match = instruction.match(/^(\d+\.)(\s*)(.*)$/);
                        return (
                          <Box key={`${instruction}-${index}`} component="span" style={{ display: 'block', marginBottom: index < displayInstructions.length - 1 ? 4 : 0 }}>
                            {match ? <><strong>{match[1]}</strong>{match[2]}{match[3]}</> : instruction}
                          </Box>
                        );
                      })
                      : displayDescription}
                  </Typography>
                  {isAscendExercise && (tips.length > 0 || commonMistakes.length > 0) && (
                    <Box display="flex" justifyContent="center">
                      <Button
                        onClick={() => setGuidanceDrawer('guidance')}
                        style={{
                          background: '#f7f9fc',
                          color: '#002D55',
                          borderRadius: 14,
                          padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                          margin: '12px 0 2px',
                          minWidth: 0,
                          textTransform: 'none',
                          fontSize: 'clamp(0.7rem, 0.9vw, 0.875rem)',
                          fontWeight: 600,
                        }}
                        startIcon={<WarningIcon style={{ color: '#fb741a', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />}
                      >
                        Common mistakes
                      </Button>
                    </Box>
                  )}
                </Box>
                {((!isAscendExercise && Array.isArray(props.exercise.instructions) && props.exercise.instructions.length > 0)
                  || tips.length > 0
                  || commonMistakes.length > 0) && (
                  <Box display="flex" justifyContent="center" flexWrap="wrap" style={{ marginBottom: 8 }}>
                    {!isAscendExercise && Array.isArray(props.exercise.instructions) && props.exercise.instructions.length > 0 && (
                      <Button className={classes.button} onClick={() => setGuidanceDrawer('instructions')} startIcon={<ListAltIcon />}>
                        Instructions
                      </Button>
                    )}
                    {!isAscendExercise && (tips.length > 0 || commonMistakes.length > 0) && (
                      <Button className={classes.button} onClick={() => setGuidanceDrawer('guidance')} startIcon={<HelpOutlineIcon />}>
                        Common mistakes
                      </Button>
                    )}
                  </Box>
                )}
              </Grid>
              <Grid container direction="row" justify="center" style={{ marginRight: 10, width: "88%", marginTop: "0%", marginBottom: "1%" }}>
                <Grid container xs={12} direction="row" justify="center" alignItems="center" style={{ padding: 0, marginLeft: 0, marginRight: 0 }}>
                  <Button autoFocus onClick={props.handleClose} className={classes.continueButton} style={{ marginRight: 5 }}>
                    START 
                  </Button>
                  <Button onClick={props.onSkip} className={classes.skipButton} style={{ marginLeft: 5 }}>
                    SKIP
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Paper>
      </div>
      <Drawer anchor="right" open={guidanceDrawer !== null} onClose={() => setGuidanceDrawer(null)}>
        <Box style={{ width: 'min(86vw, 380px)', padding: 20, boxSizing: 'border-box' }}>
          <Typography variant="h6" className={classes.h5} style={{ textAlign: 'left', marginBottom: 16 }}>
            {guidanceDrawer === 'instructions' ? 'Instructions' : 'Guidance'}
          </Typography>
          {guidanceDrawer === 'instructions' ? (
            <List style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {(props.exercise.instructions || []).map((item, index) => (
                <ListItem key={`instruction-${index}`} alignItems="flex-start">
                  <Typography variant="body2" style={{ color: '#002D55', whiteSpace: 'pre-wrap' }}>
                    {`${index + 1}. ${item}`}
                  </Typography>
                </ListItem>
              ))}
            </List>
          ) : (
            <Box style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {tips.length > 0 && (
                <>
                  <Typography variant="subtitle1" style={{ color: '#002D55', fontWeight: 700, marginTop: 8 }}>Tips</Typography>
                  <List>
                    {tips.map((item, index) => (
                      <ListItem key={`tip-${index}`} alignItems="flex-start">
                        <Typography variant="body2" style={{ color: '#002D55', whiteSpace: 'pre-wrap' }}>{`${index + 1}. ${item}`}</Typography>
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
              {commonMistakes.length > 0 && (
                <>
                  <Typography variant="subtitle1" style={{ color: '#002D55', fontWeight: 700, marginTop: 8 }}>Common mistakes</Typography>
                  <List>
                    {commonMistakes.map((item, index) => (
                      <ListItem key={`mistake-${index}`} alignItems="flex-start">
                        <Typography variant="body2" style={{ color: '#002D55', whiteSpace: 'pre-wrap' }}>{`${index + 1}. ${item}`}</Typography>
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
            </Box>
          )}
        </Box>
      </Drawer>
    </Popover>
  );
};


export default ExerciseIntro;
